import React from 'react';
import { withStyles, WithStyles, createStyles } from '@material-ui/core';

import { HubspotFormContainer as HubspotForm } from 'ha/modules/HubspotForm';
import { HUBSPOT_PORTAL_ID } from 'ha/modules/HubspotForm/constants';
import { Box, Card, CardContent, Typography, units } from '@ha/dsl';

interface Props {
  hubspotFormId: string;
  title: string;
  text: string;
  buttonText: string;
}

export const styles = () =>
  createStyles({
    root: {
      padding: units.txb(1.25, 1.5, 0),
      paddingBottom: '0 !important',
    },
    title: {
      marginBottom: units.rem(0.5),
    },
    text: {
      marginBottom: units.rem(1.25),
    },
  });

const BlogFormInternal: React.FC<Props & WithStyles<typeof styles>> = ({
  hubspotFormId,
  title,
  text,
  buttonText,
  classes,
}) => (
  <Card>
    <CardContent className={classes.root}>
      <Typography.H2
        component="h2"
        className={classes.title}
        data-test-locator="Blog BlogForm Title"
      >
        {title}
      </Typography.H2>
      <Typography.Paragraph
        component="p"
        className={classes.text}
        data-test-locator="Blog BlogForm Text"
      >
        {text}
      </Typography.Paragraph>
      <Box mb={2}>
        <HubspotForm
          portalId={HUBSPOT_PORTAL_ID}
          formId={hubspotFormId}
          submitText={buttonText}
          data-test-locator="Blog BlogForm HubspotForm"
        />
      </Box>
    </CardContent>
  </Card>
);

const BlogForm = withStyles(styles)(BlogFormInternal);
export { BlogForm };
